<template>
    <div>
        <v-list dense class="pt-0" v-for="(item, index) in list_menu" :key="index">
            <v-subheader class="sub-header">{{ item.title }}</v-subheader>
            <v-list-item-group v-model="item.model" color="primary">
                <template v-for="(menu, i) in item.list">
                    <v-list-item @click="toPage(menu.path)" v-if="menu.status === undefined || menu.status === 'true'">
                        <v-list-item-icon>
                            <v-icon v-text="menu.icon" class="fz-18"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="menu.text"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="i < item.list.length - 1 && item.divider !== null" :key="i"></v-divider>
                </template>
            </v-list-item-group>
        </v-list>
        <!-- <v-list dense class="pt-0">
            <v-subheader class="sub-header">{{$t('HeaderMenubar.general')}}</v-subheader>
            <v-list-item-group v-model="selectedItemGeneral" color="primary">
                <template v-for="(item, i) in list_general">
                <v-list-item @click="toPage(item.path)">
                    <v-list-item-icon>
                        <v-icon v-text="item.icon" class="fz-18"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider
                    v-if="i < list_general.length - 1"
                    :key="i"
                ></v-divider>
                </template>
            </v-list-item-group>
        </v-list> -->
    </div>
</template>
<script>
// import router from '@/router';

export default {
    data: () => ({
        selectedItem: null,
        selectedItemGeneral: null,
        list_setting: [],
        list_general: [],
        list_menu: [],
        login_page: "",
        data_user: {},
    }),
    watch: {
        '$i18n.locale' () {
            this.list_setting = [
                { text: this.$t('HeaderMenubar.editProfile'), icon: 'fa-solid fa-user', path: '/web/profile' },
                { text: this.$t('HeaderMenubar.managefriend'), icon: 'fa-solid fa-user-group', path: '/web/friend' },
                { text: this.$t('HeaderMenubar.loa'), icon: 'fa-solid fa-user-shield', path: 'loa' },
            ]
            this.list_general = [
                { text: this.$t('HeaderMenubar.languages'), icon: 'fa-solid fa-globe', path: '/web/languages' },
                { text: this.$t('HeaderMenubar.logout'), icon: 'fa-solid fa-right-from-bracket', path: 'logout', status: this.login_page },
            ]
            this.list_menu = [
                { list: this.list_setting, title: this.$t('HeaderMenubar.profile'), model: this.selectedItem, divider: true },
                { list: this.list_general, title: this.$t('HeaderMenubar.general'), model: this.selectedItemGeneral, divider: this.login_page }
            ]
        }
    },
    created() {
        this.login_page = this.$cookie.get('login-page')
        // console.log("this.login_page => ", this.login_page);
        this.list_setting = [
            { text: this.$t('HeaderMenubar.editProfile'), icon: 'fa-solid fa-user', path: '/web/profile' },
            { text: this.$t('HeaderMenubar.managefriend'), icon: 'fa-solid fa-user-group', path: '/web/friend' },
            { text: this.$t('HeaderMenubar.loa'), icon: 'fa-solid fa-user-shield', path: 'loa' },
        ]
        this.list_general = [
            { text: this.$t('HeaderMenubar.languages'), icon: 'fa-solid fa-globe', path: '/web/languages' },
            { text: this.$t('HeaderMenubar.logout'), icon: 'fa-solid fa-right-from-bracket', path: 'logout', status: this.login_page },
        ]
        this.list_menu = [
            { list: this.list_setting, title: this.$t('HeaderMenubar.profile'), model: this.selectedItem, divider: true },
            { list: this.list_general, title: this.$t('HeaderMenubar.general'), model: this.selectedItemGeneral, divider: this.login_page }
        ]
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        this.data_user = user_profile['account']['profile']
    },
    methods: {
        toPage(path) {
					// console.log("path => ", path);
					// var me = this;
					this.$router.push(path)
					if (path === 'logout') {
						this.$cookie.delete('login-page')
						this.$cookie.delete('one_token')
						path = `${process.env.VUE_APP_URL_PRIVATE}/login?business_id=${this.data_user.one_id}&status_login=false`
						window.open(path, '_self')
					} else if (path === 'loa') {
                        var url = process.env.VUE_APP_API_LOA
                        var body = {
                            "tokenuser": this.data_user.tokenuser,
                            "url": url
                        }
                        this.axios.post(process.env.VUE_APP_API_NEW_GET_ACCESS_TOKEN, body).then((response) => {
                            window.open(url + response.data.data.accesstoken, '_blank')
                        })
                        this.$router.push('/web')
                     }else {
						this.$router
							.push(path)
							.catch((error) => {
								if (error.name != "NavigationDuplicated") {
									throw error;
								}
						});
					}
        },
    },
}
</script>
<style lang="css" scoped>
.fz-18 {
    font-size: 18px !important;
}

.sub-header {
    background-color: rgb(239, 239, 239) !important;
    color: black !important;
    font-size: 14px !important;
}
</style>